const downloadSpecialReportQuery = ({ filter, url, exportFormat = 1 }) => {
  // Transform keys to capitalize first letter
  const transformParamsKeys = Object.entries(filter).reduce(
    (prev, [key, value]) => ({
      ...prev,
      [key.charAt(0).toUpperCase() + key.slice(1)]: value,
    }),
    {},
  )

  // Filter out empty or null values
  const filterParams = Object.entries(transformParamsKeys).reduce(
    (memo, [key, value]) => {
      // eslint-disable-next-line no-param-reassign
      if (value !== '' && value !== null) memo[key] = value
      return memo
    },
    {},
  )

  // Always include exportFormat in params
  filterParams.FileExportFormat = exportFormat

  // Build query string
  const params = new URLSearchParams(filterParams).toString()
  const searchURL = params ? `${url}?${params}` : url

  return searchURL
}

export default downloadSpecialReportQuery
